
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisSarAircraftHelicopterIec as ObiAisSarAircraftHelicopterIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-sar-aircraft-helicopter-iec.js';
 
 
 

 
 export const ObiAisSarAircraftHelicopterIec = createComponent({
   react: React,
   tagName: 'obi-ais-sar-aircraft-helicopter-iec',
   elementClass: ObiAisSarAircraftHelicopterIecElement,
   events: {
     
   }
  });
 
 